import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { AppRouterConstants } from '../../../components/appRouter/AppRouter.constants'
import { IQaFlagDetail } from '../qaAddendums/store/qaAddendum.types'
import { fetchQaFlagDetail } from '../qaAddendums/store/qaAddendum.actions'
import {
  getQaAddendumSelector,
  getSelectedFlagDetailSelector,
  getSelectedFlagIdSelector,
} from '../qaAddendums/selectors'

interface IQaFlagNavigation {
  flagId: string
  flagDetail: IQaFlagDetail | null
  isDetailLoading: boolean
}

export const useQAFlagNavigation = (): IQaFlagNavigation => {
  const dispatch = useDispatch()
  const history = useHistory()

  const flagId = useSelector(getSelectedFlagIdSelector) ?? ''
  const selectedFlagDetail = useSelector(getSelectedFlagDetailSelector)
  const { isDetailLoading, detailFlagId } = useSelector(getQaAddendumSelector)

  useEffect(() => {
    if (!flagId) history.replace(AppRouterConstants.HOME_ROUTE)
  }, [])

  const flagDetail = selectedFlagDetail && String(selectedFlagDetail.flagId) === flagId ? selectedFlagDetail : null

  useEffect(() => {
    if (flagId && detailFlagId !== flagId && !isDetailLoading) {
      dispatch(fetchQaFlagDetail(flagId))
    }
  }, [dispatch, flagId, detailFlagId, isDetailLoading])

  return { flagId, flagDetail, isDetailLoading }
}
